import { create } from 'zustand';

export const useInitiativesStore = create((set, get) => ({
  items: [],
  filters: { status: '', priority: '', search: '' },
  sortBy: 'createdAt',
  sortOrder: 'desc',

  setItems: (items) => set({ items: Array.isArray(items) ? items : [] }),
  addItem: (item) => set({ items: [...get().items, item] }),
  updateItem: (id, updates) => set({ items: get().items.map(i => i.id === id ? { ...i, ...updates } : i) }),
  removeItem: (id) => set({ items: get().items.filter(i => i.id !== id) }),

  setFilters: (filters) => set({ filters: { ...get().filters, ...filters } }),
  setSort: (sortBy, sortOrder = get().sortOrder) => set({ sortBy, sortOrder }),

  // Derived selectors
  getFilteredSorted: () => {
    const { items, filters, sortBy, sortOrder } = get();
    let list = Array.isArray(items) ? [...items] : [];
    const search = (filters.search || '').toLowerCase();
    if (filters.status) list = list.filter(i => i.status === filters.status);
    if (filters.priority) list = list.filter(i => i.priority === filters.priority);
    if (search) list = list.filter(i =>
      (i.title || '').toLowerCase().includes(search) ||
      (i.description || '').toLowerCase().includes(search) ||
      (i.objective || '').toLowerCase().includes(search)
    );
    list.sort((a, b) => {
      let av = a[sortBy];
      let bv = b[sortBy];
      if (sortBy === 'createdAt' || sortBy === 'updatedAt') {
        av = new Date(av || 0).getTime();
        bv = new Date(bv || 0).getTime();
      } else if (typeof av === 'string' && typeof bv === 'string') {
        av = av.toLowerCase();
        bv = bv.toLowerCase();
      }
      if (av < bv) return sortOrder === 'asc' ? -1 : 1;
      if (av > bv) return sortOrder === 'asc' ? 1 : -1;
      return 0;
    });
    return list;
  }
}));

// Non-hook helpers
export const initiativesStore = {
  setItems: (items) => useInitiativesStore.getState().setItems(items),
  addItem: (item) => useInitiativesStore.getState().addItem(item),
  updateItem: (id, updates) => useInitiativesStore.getState().updateItem(id, updates),
  removeItem: (id) => useInitiativesStore.getState().removeItem(id),
  setFilters: (f) => useInitiativesStore.getState().setFilters(f),
};

